module.exports = __webpack_public_path__ + "media/images/covid/menu/other-a4724be473173df7ea614bece2ffcf6c.png";